'use strict';

var app = angular.module('harriApp');

app.directive('lightSignUp',['$stateParams', 'hUser', '$state', 'localize', function ($stateParams, hUser, $state, localize) {
    return {
        templateUrl: '../modules/hforms/light_signup/views/light_signup_form.html',
        restrict: 'E',
        link: function (scope, iElement, iAttrs) {

            var code = $stateParams.code;
            var redirectLink = $stateParams.redirect_url;
            let clientId;
            if (LOGIN_BRANDS.FULHAM_SHORE === ($stateParams.brand || '').toLowerCase()) {
                clientId = LOGIN_BRANDS.FULHAM_SHORE;
            }
            scope.form = new LightSignupForm(scope, code, hUser, $state, redirectLink, localize, clientId);

            scope.form.onViewLoaded();
        }
    };
}]);